import { useEffect } from "react";

import { TemplateCategory } from "@/components/confluence/templates/template-categories-search";
import type {
    Template,
    TemplateCollection
} from "@/content/templates/template.types";
import { ConfluenceTemplatesCollectionDetailsPageTemplate } from "@/templates/software/confluence/templates/confluence-templates-page/src";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export type ConfluenceTemplateCollectionDetailsPageProps = {
    templates?: Template[];
    collections?: TemplateCollection[];
    categories?: TemplateCategory[];
};

export const ConfluenceTemplateCollectionDetailsPage = ({
    templates,
    collections,
    categories
}: ConfluenceTemplateCollectionDetailsPageProps) => {
    useEffect(() => {
        checkFeatureFlagGate(
            featureFlags.gwpRelayConfTemplateCollectionDetails
        );
    }, []);

    useEffect(() => {
        checkFeatureFlagGate(
            featureFlags.cpapiwdConfluenceTemplateCollectionDetails
        );
    }, []);

    return (
        <ConfluenceTemplatesCollectionDetailsPageTemplate
            templates={templates}
            collections={collections}
            categories={categories}
        />
    );
};
